// Footer.js
import React, { useState } from 'react';

import '../CSS/Components/Footer.css'; // Import the CSS file

// Import images from the src folder
import InstagramLogoWhite from '../Images/InstagramWhiteLogo.svg';
import LinkedInWhiteLogo from '../Images/LinkedInWhiteLogo.svg';
import LinkLogoWhite from '../Images/CopyLinkWhiteLogo.svg';

import InstagramLogoBlack from '../Images/InstagramBlackLogo.svg';
import LinkedInBlackLogo from '../Images/LinkedInBlackLogo.svg';
import LinkLogoBlack from '../Images/LinkLogoBlack.png';

const instagramUrl = 'https://www.instagram.com/yusefagency/';
const linkedInUrl = 'https://www.linkedin.com/company/yusef-agency/';

function Footer({ currentSection }) {
  const [copyLabel, setCopyLabel] = useState('Copy Link');
  const safeCurrentSection = currentSection[0] || "video0"; // fallback to "video1" or something safe

  const isLightSection =
    currentSection[2] === true ||
    safeCurrentSection === "video0" ||
    safeCurrentSection === "video1" ||
    safeCurrentSection === "video2" ||
    safeCurrentSection === "video3" ||
    safeCurrentSection === "video4" ||
    safeCurrentSection === "home" ||
    safeCurrentSection === "services" ||
    safeCurrentSection === "ecom" ||
    safeCurrentSection === "vision" ||
    safeCurrentSection === "store" ||
    safeCurrentSection === "about";

  const footerLinks = isLightSection
    ? [
        { id: 'Instagram', src: InstagramLogoWhite, url: instagramUrl },
        { id: 'LinkedIn', src: LinkedInWhiteLogo, url: linkedInUrl },
        { id: 'Copy Link', src: LinkLogoWhite },
      ]
    : [
        { id: 'Instagram', src: InstagramLogoBlack, url: instagramUrl },
        { id: 'LinkedIn', src: LinkedInBlackLogo, url: linkedInUrl },
        { id: 'Copy Link', src: LinkLogoBlack },
      ];

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopyLabel('Copied');
      window.setTimeout(() => setCopyLabel('Copy Link'), 1800);
    } catch (error) {
      console.error('Failed to copy current page link.', error);
      setCopyLabel('Copy Failed');
      window.setTimeout(() => setCopyLabel('Copy Link'), 1800);
    }
  };

  return (
    <div>
      <div className={`footer ${safeCurrentSection === 'ecom' ? 'footer--hidden' : ''}`}>
      {footerLinks.map((link) => (
        link.id === 'Copy Link' ? (
          <button
            key={link.id}
            type="button"
            className="socialsLink socialsButton"
            aria-label={copyLabel}
            title={copyLabel}
            onClick={handleCopyLink}
          >
            <img src={link.src} alt="Copy current page link" />
          </button>
        ) : (
          <a
            key={link.id}
            className="socialsLink"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={link.id}
          >
            <img src={link.src} alt={link.id} />
          </a>
        )
      ))}
      </div>
  </div>
  );
}

export default Footer;


